import { Box } from "@mui/material";
import styled from "styled-components";

const Settings = () => {
  return <StyledComponent>Coming soon.</StyledComponent>;
};

const StyledComponent = styled(Box)`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;

  color: #511900;
  text-align: center;
  font-size: 10em;
  font-family: Rowdies;
  font-weight: 300;
  line-height: 90px;
`;

export default Settings;
